"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentAgsSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const date_helper_1 = require("../../helpers/date.helper");
class AssessmentAgsSerializer extends dp_http_client_lib_1.PageableSerializer {
    serializeOne(data) {
        return {
            id: data.id,
            contextId: data.contextId,
            title: data.title,
            curriculum: data.curriculum,
            sharedUserIds: data.sharedUserIds,
            status: data.status,
            startDate: data.startDate ? (0, date_helper_1.toLocalDate)(data.startDate) : null,
            assignedDate: data.assignedDate ? (0, date_helper_1.toLocalDate)(data.assignedDate) : null,
            avgScore: data.avgScore,
            maxScore: data.maxScore,
            createdAt: data.createdAt ? (0, date_helper_1.toLocalDate)(data.createdAt) : null,
            createdBy: data.createdBy,
            updatedAt: data.updatedAt ? (0, date_helper_1.toLocalDate)(data.updatedAt) : null,
            updatedBy: data.updatedBy,
        };
    }
}
exports.AssessmentAgsSerializer = AssessmentAgsSerializer;
//# sourceMappingURL=assessment-ags.serializer.js.map